import React from 'react';
import '../Studio/Studio.css';
import { Box, CardMedia, IconButton, CircularProgress, Typography , Chip} from '@mui/material';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import Masonry from 'react-masonry-css';


interface FluidComponentProps {
  items: any[];
  selectedIndex?: number;
  onSelect?: (idx: number, item: any) => void;
  onPromptClick?: (item: any, idx: number) => void;
  isLoading?: boolean;
  viewType: 'grid' | 'masonry';
  setViewType?: (type: 'grid' | 'masonry') => void;
  maxHeight?: number | string | any;
  showToggle?: boolean;
  headingText: string;
  chips?: number;
  setPopupOpen?: (open: boolean) => void;
}

const FluidComponent: React.FC<FluidComponentProps> = ({
  items,
  selectedIndex = 0,
  onSelect,
  onPromptClick,
  isLoading,
  viewType,
  setViewType,
  maxHeight = 450,
  showToggle = true,
  headingText,
  chips,
  setPopupOpen
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      {showToggle && setViewType && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, justifyContent: 'space-between' }}>
            <Box sx={{display:'flex',alignItems:'center',gap:1}}>
                <Typography variant='h6' className='productText' gutterBottom>{headingText}</Typography>
                {chips !== undefined && <Chip label={chips} className="videoChip" />}
                </Box>
            <Box>
                {viewType === 'masonry' && (
            <IconButton onClick={() => setViewType('grid')} color='default'>
              <ViewModuleIcon />
            </IconButton>
          )}
          {viewType === 'grid' && (
            <IconButton onClick={() => setViewType('masonry')} color='default'>
              <ViewQuiltIcon />
            </IconButton>
          )}
                </Box>
        </Box>
      )}
      {viewType === 'masonry' ? (
        <Box sx={{ width: '100%', maxHeight, overflowY: 'auto', height: '100%' }}>
          <Masonry
            breakpointCols={{ default: 5, 1100: 4, 700: 3, 500: 2, 300: 1 }}
            className="my-masonry-grids"
            columnClassName="my-masonry-grid_column"
          >
            {items.map((item, idx) => (
              <Box
                key={item._id || idx}
                className={`fluid-thumbnail${idx === selectedIndex ? ' active' : ''}`}
                sx={{
                  borderRadius: 2,
                  cursor: 'pointer',
                  p: 0.5,
                  border: idx === selectedIndex ? '3px solid #fff' : '1px solid transparent',
                  // boxShadow: idx === selectedIndex ? '0 0 12px 2px #fff' : 'none',
                  opacity: idx === selectedIndex ? 1 : 0.7,
                  background: '#23244A',
                  mb: 2,
                  position: 'relative',
                }}
                onClick={() => onSelect && onSelect(idx, item)}
              >
                <CardMedia
                  component='img'
                  image={item?.thumbnailUrl || item?.url || ''}
                  alt={`Thumbnail ${idx + 1}`}
                  className={item?.isGenerated ? 'videoMansoryImage' : 'blurMansoryImage'}
                  sx={{ objectFit: 'contain', width: '100%', borderRadius: 2 }}
                />
                {item?.isGenerated && (
                  <Box className="gheerButton" sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}>
                    <img
                      src={'/assets/PromptIcon.svg'}
                      alt="gheerIcon"
                      onClick={e => { e.stopPropagation(); onPromptClick && onPromptClick(item, idx);
                         onSelect && onSelect(idx, item)
                         setPopupOpen && setPopupOpen(true);
                       }}
                      className="gheerIcon"
                    />
                  </Box>
                )}
                {isLoading && (
                  <Box className='videoLoadingContainer'>
                    <CircularProgress size={24} className='videoLoadingIcon' />
                  </Box>
                )}
              </Box>
            ))}
          </Masonry>
        </Box>
      ) : (
        <Box
          className='fluid-grid-container'
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(4, 1fr)',
              xl: 'repeat(5, 1fr)'
            },
            gap: '10px',
            maxHeight,
            overflowY: 'auto',
            height: '100%',
          }}
        >
          {items.map((item, idx) => (
            <Box
              key={item._id || idx}
              className={`fluid-thumbnail${idx === selectedIndex ? ' active' : ''}`}
              sx={{
                borderRadius: 2,
                cursor: 'pointer',
                p: 0.5,
                border: idx === selectedIndex ? '3px solid #fff' : '1px solid transparent',
                // boxShadow: idx === selectedIndex ? '0 0 12px 2px #fff' : 'none',
                opacity: idx === selectedIndex ? 1 : 0.7,
                background: '#23244A',
                position: 'relative',
              }}
              onClick={() => onSelect && onSelect(idx, item)}
            >
              <CardMedia
                component='img'
                image={item?.thumbnailUrl || item?.url || ''}
                alt={`Thumbnail ${idx + 1}`}
                className={item?.isGenerated ? 'videoCardImage videoThumbnailImage' : 'blurImage'}
                sx={{ objectFit: 'contain', width: '100%', height: '100%', borderRadius: 2 }}
              />
              {item?.isGenerated && (
                  <Box className="gheerButton" sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}>
                    <img
                      src={'/assets/PromptIcon.svg'}
                      alt="gheerIcon"
                      onClick={e => { e.stopPropagation(); onPromptClick && onPromptClick(item, idx); 
                        setPopupOpen && setPopupOpen(true);
                        onSelect && onSelect(idx, item)
                      }}
                      className="gheerIcon"
                    />
                  </Box>
                )}
              {isLoading && (
                <Box className='videoLoadingContainer'>
                  <CircularProgress size={24} className='videoLoadingIcon' />
                </Box>
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default FluidComponent;
